import accedoOVP from './accedoOvp';

const ovp = accedoOVP;

export default ovp;
